import React from "react";
import { motion } from "framer-motion";
import { fadeIn } from "../variants";

const Services = () => {
  return (
    <section id="techs" className="section">
      <div className="container mx-auto h-full">
        <div className="flex flex-col">
          <motion.h2
            variants={fadeIn("right", "0.5")}
            initial="hidden"
            whileInView={"show"}
            viewport={{ once: false, amount: 0.3 }}
            className="flex-1"
          >
            <span className="h2 text-accent">Knowledges</span>
          </motion.h2>
          <motion.div
            variants={fadeIn("right", "0.5")}
            initial="hidden"
            whileInView={"show"}
            viewport={{ once: false, amount: 0.3 }}
            className="flex p-4 rounded-md max-w-7xl flex-wrap gap-6"
          >	
						<div className="card">
              <span>Javascript</span>
							<img src="https://raw.githubusercontent.com/github/explore/80688e429a7d4ef2fca1e82350fe8e3517d3494d/topics/javascript/javascript.png" alt="Javascript"  className="rounded-lg"/>
						</div>
            <div className="card">
              <span>Typescript</span>
							<img src="https://raw.githubusercontent.com/github/explore/80688e429a7d4ef2fca1e82350fe8e3517d3494d/topics/typescript/typescript.png" alt="Typescript"  className="rounded-lg"/>
						</div>
            <div className="card">
              <span>NodeJS</span>
							<img src="https://raw.githubusercontent.com/github/explore/80688e429a7d4ef2fca1e82350fe8e3517d3494d/topics/nodejs/nodejs.png" alt="NodeJS" />
						</div>
            <div className="card">
              <span>GraphQL</span>
							<img src="https://raw.githubusercontent.com/github/explore/80688e429a7d4ef2fca1e82350fe8e3517d3494d/topics/graphql/graphql.png" alt="GraphQL" className="rounded-lg"/>
						</div>
            <div className="card">
              <span>Next.js</span>
							<img src="https://raw.githubusercontent.com/github/explore/28b02bbc9ad9f7a503c43775aebeb515dc2da5fc/topics/nextjs/nextjs.png" alt="Next.js"  className="rounded-lg"/>
						</div>
            <div className="card">
              <span>React</span>
							<img src="https://raw.githubusercontent.com/github/explore/80688e429a7d4ef2fca1e82350fe8e3517d3494d/topics/react/react.png" alt="React"/>
						</div>
            <div className="card">
              <span>HTML</span>
							<img src="https://raw.githubusercontent.com/github/explore/80688e429a7d4ef2fca1e82350fe8e3517d3494d/topics/html/html.png" alt="HTML"/>
						</div>
            <div className="card">
              <span>CSS</span>
							<img src="https://raw.githubusercontent.com/github/explore/80688e429a7d4ef2fca1e82350fe8e3517d3494d/topics/css/css.png" alt="CSS"/>
						</div>
            <div className="card">
              <span>Git</span>
							<img src="https://git-scm.com/images/logos/downloads/Git-Icon-1788C.png" alt="Git"/>
						</div>
            <div className="card">
              <span>Github</span>
							<img src="https://raw.githubusercontent.com/github/explore/78df643247d429f6cc873026c0622819ad797942/topics/github/github.png" alt="CSS"/>
						</div>
            <div className="card">
              <span>Postgres</span>
							<img src="https://raw.githubusercontent.com/github/explore/80688e429a7d4ef2fca1e82350fe8e3517d3494d/topics/postgresql/postgresql.png" alt="Postgres"/>
						</div>
            <div className="card">
              <span>MongoDB</span>
							<img src="https://github.com/get-icon/geticon/raw/master/icons/mongodb-icon.svg" alt="MongoDB" className="h-[112px]"/>
						</div>
            <div className="card">
              <span>Jest</span>
							<img src="https://github.com/get-icon/geticon/raw/master/icons/jest.svg" alt="Jest" />
						</div>
            <div className="card">
              <span>Docker</span>
							<img src="https://github.com/get-icon/geticon/raw/master/icons/docker-icon.svg" alt="Docker"/>
						</div>
            <div className="card">
              <span>Kubernetes</span>
							<img src="https://github.com/get-icon/geticon/raw/master/icons/kubernetes.svg" alt="Kubernetes"/>
						</div>
            <div className="card">
              <span>Redis</span>
							<img src="https://avatars.githubusercontent.com/u/1529926?s=200&v=4" alt="Redis"/>
						</div>
            <div className="card">
              <span>AWS</span>
							<img src="https://avatars.githubusercontent.com/u/2232217?s=200&v=4" alt="AWS"  className="rounded-lg"/>
						</div>
            <div className="card">
              <span>Prisma</span>
							<img src="https://avatars.githubusercontent.com/u/17219288?s=200&v=4" alt="Prisma"  className="rounded-lg"/>
						</div>
            <div className="card">
              <span>Serverless</span>
							<img src="https://avatars.githubusercontent.com/u/13742415?s=200&v=4" alt="Serverless" className="rounded-lg"/>
						</div>
            <div className="card">
              <span>Jenkins</span>
							<img src="https://upload.wikimedia.org/wikipedia/commons/thumb/e/e9/Jenkins_logo.svg/1200px-Jenkins_logo.svg.png" alt="Jenkins" />
						</div>
					</motion.div>
        </div>
      </div>
    </section>
  );
};

export default Services;
